import { computed, getCurrentInstance } from 'vue'
import useRouter from '@/hooks/useRouter'
import { Project } from '../types/main'
export function useUser() {
    const root = getCurrentInstance()!.proxy as any
    const user = computed(() => root.$auth.user)
    return { user }
}
